import auth from "./authReducer";
import interactive from "./interactiveReducer";
import authPoll from "./authPollReducer";
import posts from "./pollReducer";

export { auth, interactive, authPoll, posts };
